import { render } from "./UploadComponentFerramentaUsuario.vue?vue&type=template&id=78057664&scoped=true"
import script from "./UploadComponentFerramentaUsuario.vue?vue&type=script&lang=js"
export * from "./UploadComponentFerramentaUsuario.vue?vue&type=script&lang=js"

import "./UploadComponentFerramentaUsuario.vue?vue&type=style&index=0&id=78057664&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78057664"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn,QChip,QCard,QCardSection});
